<template>
  <div v-if="dlg" class="ss-modal">
    <div class="ss-scrim" @click="ctl.closeDialog()"></div>
    <div
      ref="box"
      class="ss-dlg"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="ss-dlg-t"
      aria-describedby="ss-dlg-d"
      tabindex="-1"
      @keydown="onKey"
    >
      <h4 id="ss-dlg-t">{{ title }}</h4>
      <p id="ss-dlg-d">{{ text }}</p>
      <p v-if="note" class="ss-dlg__n">{{ note }}</p>
      <div class="ss-dlg__f">
        <template v-if="dlg.kind === 'leave'">
          <button type="button" class="ui-btn ui-btn--primary" data-primary @click="ctl.leaveSave()">
            {{ $t("settings_shell.dlg.leave_save") }}
          </button>
          <button type="button" class="ui-btn" @click="ctl.leaveDiscard()">{{ $t("settings_shell.dlg.leave_discard") }}</button>
          <button type="button" class="ui-btn ui-btn--ghost" @click="ctl.closeDialog()">{{ $t("settings_shell.dlg.stay") }}</button>
        </template>
        <template v-else-if="dlg.kind === 'legacy'">
          <button type="button" class="ui-btn ui-btn--primary" data-primary @click="ctl.confirmNewTimes()">
            {{ $t("settings_shell.dlg.legacy_yes") }}
          </button>
          <button type="button" class="ui-btn ui-btn--ghost" @click="ctl.closeDialog()">{{ $t("settings_shell.cancel") }}</button>
        </template>
        <template v-else>
          <button type="button" class="ui-btn ui-btn--primary ui-btn--danger" data-primary @click="ctl.confirmRemoveImage()">
            {{ $t("settings_shell.dlg.remove_yes") }}
          </button>
          <button type="button" class="ui-btn ui-btn--ghost" @click="ctl.closeDialog()">{{ $t("settings_shell.cancel") }}</button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
/** Potvrde: izlazak sa izmjenama koje nisu snimljene, uključivanje novih rokova i uklanjanje slike. */
export default {
  name: "SetDialog",
  inject: { ctl: "settingsCtl" },
  data: () => ({ opener: null }),
  computed: {
    dlg() {
      return this.ctl.ui.dlg;
    },
    title() {
      const kind = this.dlg && this.dlg.kind;
      if (kind === "leave") {
        return this.$t("settings_shell.dlg.leave_title");
      }
      return kind === "legacy" ? this.$t("settings_shell.dlg.legacy_title") : this.$t("remove_image");
    },
    text() {
      const kind = this.dlg && this.dlg.kind;
      if (kind === "leave") {
        return this.$t("settings_shell.dlg.leave_text", { n: this.ctl.changeCount });
      }
      if (kind === "legacy") {
        return this.$t("settings_shell.dlg.legacy_text");
      }
      return this.$t("remove_branding_confirmation", { type: this.ctl.labelFor(this.dlg.path) });
    },
    note() {
      return this.dlg && this.dlg.kind === "remove" ? this.$t("settings_shell.dlg.remove_note") : "";
    },
  },
  watch: {
    dlg(value, previous) {
      if (value && !previous) {
        this.opener = document.activeElement;
        this.$nextTick(() => {
          const primary = this.$refs.box && this.$refs.box.querySelector("[data-primary]");
          (primary || this.$refs.box || {}).focus && (primary || this.$refs.box).focus();
        });
      } else if (!value && previous && this.opener && document.contains(this.opener)) {
        this.opener.focus();
        this.opener = null;
      }
    },
  },
  methods: {
    onKey(event) {
      if (event.key === "Escape") {
        event.stopPropagation();
        this.ctl.closeDialog();
        return;
      }
      if (event.key !== "Tab") {
        return;
      }
      const items = [...this.$refs.box.querySelectorAll("button:not([disabled])")];
      if (!items.length) {
        return;
      }
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },
  },
};
</script>
